import { z } from 'zod';
import { WORK_HEALTH_PLATFORMS, WORK_HEALTH_WINDOWS, WORK_HEALTH_SOURCE_TYPES } from '../types/work-health.js';

export const CreateWorkHealthMemberSchema = z.object({
  name: z.string().min(1).max(200),
  email: z.string().email().optional().nullable(),
  linkedUserId: z.string().uuid().optional().nullable(),
});
export type CreateWorkHealthMemberInput = z.infer<typeof CreateWorkHealthMemberSchema>;

export const UpdateWorkHealthMemberSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  email: z.string().email().nullable().optional(),
  linkedUserId: z.string().uuid().nullable().optional(),
  active: z.boolean().optional(),
});
export type UpdateWorkHealthMemberInput = z.infer<typeof UpdateWorkHealthMemberSchema>;

export const CreateWorkHealthResponsibilitySchema = z.object({
  memberId: z.string().uuid(),
  area: z.string().min(1).max(200),
  platform: z.enum(WORK_HEALTH_PLATFORMS),
  cadence: z.enum(WORK_HEALTH_WINDOWS),
  minCount: z.number().int().min(1).max(100000),
  sourceType: z.enum(WORK_HEALTH_SOURCE_TYPES).optional().nullable(),
});
export type CreateWorkHealthResponsibilityInput = z.infer<typeof CreateWorkHealthResponsibilitySchema>;

export const UpdateWorkHealthResponsibilitySchema = z.object({
  area: z.string().min(1).max(200).optional(),
  platform: z.enum(WORK_HEALTH_PLATFORMS).optional(),
  cadence: z.enum(WORK_HEALTH_WINDOWS).optional(),
  minCount: z.number().int().min(1).max(100000).optional(),
  sourceType: z.enum(WORK_HEALTH_SOURCE_TYPES).nullable().optional(),
  active: z.boolean().optional(),
});
export type UpdateWorkHealthResponsibilityInput = z.infer<typeof UpdateWorkHealthResponsibilitySchema>;

export const CreateWorkHealthUsageSchema = z.object({
  memberId: z.string().uuid(),
  platform: z.enum(WORK_HEALTH_PLATFORMS),
  count: z.number().int().min(1).max(1000000),
  amount: z.number().min(0).optional().nullable(),
  unit: z.string().max(40).optional().nullable(),
  occurredAt: z.string().datetime(),
  note: z.string().max(2000).optional().nullable(),
  // Defaults to 'manual' server-side when omitted.
  sourceType: z.enum(WORK_HEALTH_SOURCE_TYPES).optional(),
});
export type CreateWorkHealthUsageInput = z.infer<typeof CreateWorkHealthUsageSchema>;
